var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.877276 8.38499L4.74691 12.2946C4.83986 12.3883 4.95045 12.4627 5.0723 12.5135C5.19415 12.5642 5.32484 12.5904 5.45684 12.5904C5.58884 12.5904 5.71953 12.5642 5.84138 12.5135C5.96323 12.4627 6.07382 12.3883 6.16677 12.2946C6.26049 12.2017 6.33488 12.0911 6.38564 11.9692C6.43641 11.8474 6.46254 11.7167 6.46254 11.5847C6.46254 11.4527 6.43641 11.322 6.38564 11.2001C6.33488 11.0783 6.26049 10.9677 6.16677 10.8747L2.60711 7.29509H22.9952C23.2604 7.29509 23.5147 7.18975 23.7022 7.00223C23.8897 6.81471 23.9951 6.56038 23.9951 6.29519C23.9951 6.03 23.8897 5.77567 23.7022 5.58815C23.5147 5.40063 23.2604 5.29529 22.9952 5.29529H2.54712L6.16677 1.67564C6.34404 1.48968 6.44294 1.24262 6.44294 0.985703C6.44294 0.728787 6.34404 0.481728 6.16677 0.29577C6.07382 0.20205 5.96323 0.127663 5.84138 0.0768992C5.71953 0.0261355 5.58884 0 5.45684 0C5.32484 0 5.19415 0.0261355 5.0723 0.0768992C4.95045 0.127663 4.83986 0.20205 4.74691 0.29577L0.877276 4.1454C0.315528 4.70784 0 5.47027 0 6.26519C0 7.06012 0.315528 7.82254 0.877276 8.38499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowBlack);
export default __webpack_public_path__ + "static/media/backArrowBlack.81b5f8a66758c4cf1ee2af4de24210b0.svg";
export { ForwardRef as ReactComponent };